import { render, staticRenderFns } from "./AreaManager.vue?vue&type=template&id=3d9c6cc4"
import script from "./AreaManager.vue?vue&type=script&lang=js"
export * from "./AreaManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports